import React, {Component} from 'react'
import {toJS} from 'mobx'
import {inject, observer} from 'mobx-react'
import {getPaginationConfig} from '../../../components/pagination'
import {Table, Button, Modal, Tag, Steps, Popover, Tooltip} from 'antd'
import {
  QuestionCircleFilled,
  ExclamationCircleFilled,
  CheckOutlined,
  CloseOutlined,
  DeleteOutlined,
  PauseOutlined,
  EyeOutlined,
  ClockCircleOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  StopOutlined,
  RightOutlined,
  MinusCircleFilled,
  CheckCircleFilled,
  CloseCircleFilled,
  ClockCircleFilled,
  ReloadOutlined
} from '@ant-design/icons'
import RejectModal from '../../marketingSmsManagement/components/RejectModal'
import {withTranslation} from 'react-i18next'
import history from '../../../routes/history'
import moment from 'moment';

const {confirm} = Modal
const { Step } = Steps;

@inject('intelligentOutboundCallStore', 'accountStore')
@observer
class SearchResult extends Component {
  state = {
    addModalVisible: false,
    groupModalVisible: false,
    limitModalVisible: false,
    rowRecord: {},
    limitType: '',
    groupParams: {},
    canPause: false,
  }

  componentDidMount() {
  }

  handleEdit = (record) => {
    const {intelligentOutboundCallStore} = this.props
    intelligentOutboundCallStore.onGetJobAction(record.id).then(res => {
      this.setState({
        addModalVisible: true,
      })
    })
  }
  handleDel = (record) => {
    const {intelligentOutboundCallStore, t} = this.props
    confirm({
      title: t(`general.deleteData`),
      icon: <QuestionCircleFilled/>,
      content: t(`general.sureToDelete`),
      okText: t(`general.delete`),
      cancelText: t(`general.cancel`),
      onOk() {
        intelligentOutboundCallStore.onDeleteJobAction(record?.id)
      },
      onCancel() {
      },
    })
    return false
  }
  handleClose = (record) => {
    const {intelligentOutboundCallStore, t} = this.props
    confirm({
      title: t(`general.closeData`),
      icon: <QuestionCircleFilled/>,
      content: t(`general.sureToClose`),
      okText: t(`general.close`),
      cancelText: t(`general.cancel`),
      onOk() {
        intelligentOutboundCallStore.onCloseJobAction(record?.id)
      },
      onCancel() {
      },
    })
    return false
  }
  handlePageChange = (page, pageSize) => {
    const {intelligentOutboundCallStore} = this.props
    intelligentOutboundCallStore.onChangePageNumAction(page, pageSize)
  }
  getRowClassName = (record, index) => {
    let className = ''
    className = index % 2 === 0 ? 'oddRow' : 'evenRow'
    return className
  }

  handlePause = (record, type) => {
    const {intelligentOutboundCallStore,t} = this.props
    confirm({
      title: type === 'pause' ? t(`general.pauseData`) : t(`general.goData`),
      icon: <QuestionCircleFilled/>,
      content: type === 'pause' ? t(`general.pauseToData`) : t(`general.goToData`),
      okText: type === 'pause' ? t(`general.pause`) : t(`general.go`),
      cancelText: t(`general.cancel`),
      onOk() {
        intelligentOutboundCallStore.onPauseAction(record?.id)
      },
      onCancel() {
      },
    })
    return false
  }
  handleDetails = (record) => {
    const {type} = this.props
    history.push(`/intelligentCallDetails?${record?.id}`, {record,type})
  }
  handleAgree = (record) => {
    const {intelligentOutboundCallStore, t} = this.props
    confirm({
      title: t(`general.agreeData`),
      icon: <QuestionCircleFilled/>,
      content: t(`general.agreeToData`),
      okText: t(`general.agree`),
      cancelText: t(`general.cancel`),
      className: "agree",
      onOk() {
        const params = {
          "approveStatus": 'APPROVED',
          "taskId": record?.id,
        }
        intelligentOutboundCallStore.onAgreeAction(params)
      },
      onCancel() {
      },
    })
    return false
  }
  handleReject = (record) => {
    this.setState({
      "addModalVisible": true,
      "taskId": record?.id,
    })
  }
  handleCancel = () => {
    this.setState({
      addModalVisible: false
    })
  }

  handleRetry = (record) => {
    const {intelligentOutboundCallStore, t} = this.props
    confirm({
      title: t(`general.retryData`),
      icon: <QuestionCircleFilled/>,
      okText: t(`general.ok`),
      cancelText: t(`general.cancel`),
      onOk() {
        intelligentOutboundCallStore.onRetryAction(record?.id)
      },
      onCancel() {
      },
    })
    return false
  }

  render() {
    const {intelligentOutboundCallStore, t} = this.props
    const {pageNo, pageSize, itemCount, jobList, statusList, taskList} = intelligentOutboundCallStore
    const pagination = getPaginationConfig(pageNo, pageSize, itemCount, this.handlePageChange)
    const customDot = (dot, { status, index }, stepData) => { 
      const { approver, approveTime, approveStatus, comment } = stepData;
      return (
      <Popover
        content={<>
          <div>审批人： {approver} </div>
          <div>审批时间： {approveTime} </div>
          <div>审批状态： {statusList?.find(a=> a?.code === approveStatus)?.name}</div>
          {approveStatus==='REJECTED' ? <div>原因： {comment} </div> : null}
        </>}
      >
        {!approver ? <MinusCircleFilled style={{color: 'rgba(0, 0, 0, 0.25)'}} /> : approveStatus==='APPROVED' ? <CheckCircleFilled style={{color: 'green'}} /> : approveStatus==='REJECTED' ? <CloseCircleFilled style={{color: 'red'}} /> : approveStatus==='PENDING' ? <ClockCircleFilled style={{color: 'rgba(0, 0, 0, 0.25)'}} /> : <MinusCircleFilled />}
      </Popover>
    )};
    const columns = [
      // {
      //   width: 200,
      //   align: 'center',
      //   title: t(`outboundCall.id`),
      //   dataIndex: 'id',
      //   key: 'id',
      //   ellipsis: true
      // },
      {
        title: t(`outboundCall.groupName`),
        dataIndex: 'marketGroupName',
        key: 'marketGroupName',
        ellipsis: true,
        width: 140,
      },
      {
        title: t(`outboundCall.taskName`),
        dataIndex: 'taskName',
        key: 'taskName',
        ellipsis: true,
        width: 240,
      },
      {
        title: t(`outboundCall.taskScheduleDetails`),
        width: 300,
        render: (_, record) => (
          <>
            <div>
              <strong>执行日期：</strong>
              {record.executionDate}
            </div>
            <div>
              <strong>执行星期：</strong>
              {record.executionWeek}
            </div>
            <div>
              <strong>执行时间段：</strong>
              {record.executionTimePeriod}
            </div>
          </>
        )
      },
      {
        title: t(`outboundCall.taskStatus`),
        dataIndex: 'taskStatus',
        key: 'taskStatus',
        ellipsis: true,
        width: 180,
        render: (text, record) => (
          <>
            <Tag color={text==='APPROVED' || text==='FINISHED' ? "success" : text==='REJECTED' || text==='FAILED' ? "error" : text==='CLOSED' ? null : "cyan" }>
              {text==='APPROVED' || text==='FINISHED' ? <CheckCircleOutlined /> : text==='REJECTED' || text==='FAILED' ? <CloseCircleOutlined /> : text==='CLOSED' ? <StopOutlined /> : <ClockCircleOutlined />}
              {' '}
              {taskList?.find(a=> a?.code===text)?.name}
            </Tag><br />
            {record?.scheduledSendTime  ? moment() < moment(record?.scheduledSendTime) ? <Tag color="blue" style={{height: 'auto'}}>定时发送时间：<br />{record.scheduledSendTime}</Tag> : null : null}
          </>
        )
      },
      {
        title: t(`marketingManagement.approvalStatus`),
        dataIndex: 'approveList',
        key: 'approveList',
        ellipsis: true,
        width: 140,
        render: (text, record) => (
          <Steps style={{width: '100%'}} progressDot={(dot, { status, index }) =>
            customDot(dot, { status, index }, text[index])
          }>
            {text?.map((a,i)=> {return <Step key={i} status={
              a?.approveStatus==='6' ? 'wait' : a?.approveStatus==='1' ? 'process' : a?.approveStatus==='3' ? 'Finished' : a?.approveStatus==='4' ? 'error'
            : null} />})}
          </Steps>
        )
      },
      {
        title: t(`outboundCall.listTotal`),
        dataIndex: 'approveLogList',
        key: 'approveLogList',
        ellipsis: true,
        width: 270,
        render: (text, record) => (
          <div>
            <div style={{display: 'flex', justifyContent: 'space-between', color: '#40a9ff'}}>
              <div>外呼总数量: {record.totalCount}</div>
              <div>呼叫中: {record.processingCount}</div>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-between', color: '#73d13d'}}>
              <div>呼叫成功: {record.successCount}</div>
              <div>成功率: {record.successRate}</div>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-between', color: '#ff4d4f'}}>
              <div>呼叫失败: {record.failedCount}</div>
              <div>失败率: {record.failedRate}</div>
            </div>
          </div>
        )
      },
      {
        title: <>
          {t(`outboundCall.billingDuration`)}
          <Tooltip title={t(`outboundCall.billingDurationTips2`)}>
            <ExclamationCircleFilled />
          </Tooltip>
        </>,
        dataIndex: 'billableDuration',
        key: 'billableDuration',
        ellipsis: true,
        width: 160,
      },
      {
        title: t(`outboundCall.smsStatistics`),
        dataIndex: 'smsStatistics',
        key: 'smsStatistics',
        ellipsis: true,
        width: 270,
        render: (text, record) => (
          <div>
            <div style={{display: 'flex', justifyContent: 'space-between', color: '#40a9ff'}}>
              <div>短信总数量: {record.smsTotalCount}</div>
              <div>发送中: {record.smsProcessingCount}</div>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-between', color: '#73d13d'}}>
              <div>发送成功: {record.smsSuccessCount}</div>
              <div>成功率: {record.smsSuccessRate}</div>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-between', color: '#ff4d4f'}}>
              <div>发送失败: {record.smsFailedCount}</div>
              <div>失败率: {record.smsFailedRate}</div>
            </div>
          </div>
        )
      },
      {
        title: t(`outboundCall.smsBillCount`),
        dataIndex: 'smsBillCount',
        key: 'smsBillCount',
        ellipsis: true,
        width: 140,
      },
      {
        title: t(`marketingManagement.exhibitionSession`),
        dataIndex: 'expoResume',
        key: 'expoResume',
        ellipsis: true,
        width: 140,
      },
      {
        title: t(`outboundCall.scenarioModel`),
        dataIndex: 'sceneModelName',
        key: 'sceneModelName',
        ellipsis: true,
        width: 140,
      },
      {
        title: t(`outboundCall.taskType`),
        dataIndex: 'taskType',
        key: 'taskType',
        ellipsis: true,
        width: 140,
        render: (text, record) => (
          <>
            {text===1 ? t(`outboundCall.taskType2`) : text===0 ? t(`outboundCall.taskType1`) : null}
          </>
        )
      },
      {
        title: t(`outboundCall.time`),
        dataIndex: 'submitTime',
        key: 'submitTime',
        ellipsis: true,
        width: 240,
        render: (text, record) =>
          <div>
            <div>提交时间: {record.createTime}</div>
            <div>发送时间: {record.sendTime}</div>
          </div>
      },
      {
        width: 280,
        align: 'center',
        title: t(`general.action`),
        key: 'action',
        fixed: 'right',
        render: (text, record) => (
          <>
            { record?.canApprove ? <>
              <Button type="link" style={{color: 'green'}} onClick={() => this.handleAgree(record)} icon={<CheckOutlined />} title={t(`general.agree`)}/>
              <Button type="link" style={{color: 'red'}} onClick={() => this.handleReject(record)} icon={<CloseOutlined />} title={t(`general.reject`)}/>
              </> : null }
            <Button type="link" onClick={() => this.handleDetails(record)} icon={<EyeOutlined />} title={t(`general.details`)}/>
            { record?.taskStatus==='PAUSED' ? 
              <Button type="link" onClick={() => this.handlePause(record, 'go')} icon={<RightOutlined />} title={t(`general.go`)}/> 
            : null} 
            { record?.taskStatus==='CALLING' ? 
              <Button type="link" onClick={() => this.handlePause(record, 'pause')} icon={<PauseOutlined />} title={t(`general.pause`)}/>
             : null }
            { record?.taskStatus==='UNSUBMITTED' || record?.taskStatus==='APPROVING' || record?.taskStatus==='APPROVED' || record?.taskStatus==='REJECTED' ? <>
                <Button type="link" onClick={() => this.handleDel(record)} icon={<DeleteOutlined />} title={t(`general.delete`)}/>
              </> : null }
            { record?.taskStatus==='UPLOADING' || record?.taskStatus==='UPLOADED' || record?.taskStatus==='PENDING_EXECUTION' || record?.taskStatus==='CALLING' || record?.taskStatus==='PAUSED' || record?.taskStatus==='SYSTEM_PAUSED' || record?.taskStatus==='EXPIRED' ? <>
                <Button type="link" onClick={() => this.handleClose(record)} icon={<CloseOutlined />} title={t(`general.close`)}/>
              </> : null }
            {
              record?.taskStatus === 'UPLOADING' && record?.canRetryUpload
                ? <Button type="link" onClick={() => this.handleRetry(record)} icon={<ReloadOutlined/>} title={t(`outboundCall.retry`)}/>
                : null
            }
          </>
        )
      }
    ]
    return (
      <>
        <Table 
          className="searchResult" 
          dataSource={toJS(jobList)} 
          pagination={pagination} 
          rowKey="id" 
          rowClassName={this.getRowClassName}
          columns={columns}
          scroll={{x: '130%'}}
        />
        {this.state.addModalVisible ? <RejectModal
          addModalVisible={this.state.addModalVisible}
          handleCancel={this.handleCancel}
          taskId={this.state.taskId}
          groupId={this.state.groupId}
          isCall={true}
        /> : null}
      </>
    )
  }
}

export default withTranslation()(SearchResult)
